export const EMR_REPORT_TYPES = {
  PRESCRIPTION: 'prescription',
  THERAPY_REPORT: 'therapy-report',
  SCREENING_REPORT: 'screening-report',
}

export const TAB_OPTIONS = [
  { id: 'prescription', label: 'Prescription' },
  { id: 'patient_history', label: 'Patient History' },
  { id: 'investigations', label: 'Investigations' },
  { id: 'therapy_report', label: 'Therapy Report' },
  { id: 'screening_report', label: 'Screening Report' },
  { id: 'vitals', label: 'Vitals' },
  { id: 'activity_plans', label: 'Activity Plans' },
  { id: 'rx', label: 'RX' },
  { id: 'report-preview', label: 'Report Preview/Print' },
  { id: 'consultation_screening_report', label: 'Consultation Screening Report' },
]
